// import './UserWithdrawHistry.css';
import CloseIcon from "@mui/icons-material/Close";
import { Avatar, Box, Button, Grid2 } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Pagination from "@mui/material/Pagination";
import { styled, useTheme } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import consts from "../../constant";
import Header from "../Header/Header";
import "./TradePair.css";

const drawerWidth = 260;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(2),
        justifyContent: "center",
    },
}));

const Network = () => {
    const token = localStorage.getItem("adminToken");
    const [result, setResult] = useState([]);
    const Navigate = useNavigate();
    const tabelHeader = [
        "S.no",
        "Network Name",
        "Network URL",
        "Action"
    ];

    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const [pairList, setpairList] = useState();
    const [addpage, setaddpage] = useState(false);
    const [on, seton] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [loader, setloader] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [networkname, setNetworkName] = useState("");
    const [rpcUrl, setRpcUrl] = useState("");
    const [totalPage, setTotalPage] = useState(0);



    const getNetworks = async () => {
        if (localStorage.getItem("adminToken")) {
            setloader(true);
            Axios.get(
                `${consts.BackendUrl}/admin/networks`,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization",
                        "Access-Control-Allow-Credentials": "true",
                        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                        Authorization: token,
                    },
                }
            )
                .then((res) => {
                    if (res?.data?.result.length > 0) {
                        setResult(res?.data?.result);
                        setloader(false);
                        setTotalPage(Math.ceil(res?.data?.result.length / limit));
                    }
                })
                .catch((err) => {
                    setloader(false);
                });
        } else {
            setloader(false);
            Navigate(`/${consts.route}/login`);
        }
    };

    useEffect(() => {
        getNetworks();
    }, []);

    const [openModel, setOpenmodel] = useState(false);
    const [pairDetils, setPairDetils] = useState({});
    const [openCreateModel, setOpenCreatemodel] = useState(false);

    const handleClickOpen = (row) => {
        setPairDetils(row);
        setOpenmodel(true);
    };
    const handleClose = () => {
        setOpenmodel(false);
    };


    // Handles save button click
    const handleSave = async () => {

        try {
            setIsLoad(true);
            const response = await Axios.post(`${consts.BackendUrl}/admin/editnetworks`, { updateData: pairDetils, id: pairDetils?._id }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization",
                    "Access-Control-Allow-Credentials": "true",
                    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                    Authorization: token,
                },
            });
            if (response?.data?.success) {
                setTimeout(() => {
                    toast.success(response?.data?.message);
                }, 1000);
                setOpenmodel(false);
                getNetworks();
            } else {
                toast.error(response?.data?.message);
            }

        } catch (error) {
            console.error("Error updating Pair", error);
        } finally {
            setIsLoad(false);
        }
    };

    const createNetwork = async () => {
        try {
            setIsLoad(true);
            const response = await Axios.post(`${consts.BackendUrl}/addnetwork`, { Network_name: networkname, Rpcurl: rpcUrl }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization",
                    "Access-Control-Allow-Credentials": "true",
                    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                    Authorization: token,
                },
            });
            if (response?.data?.success) {
                setTimeout(() => {
                    toast.success(response?.data?.message);
                }, 1000);
                setOpenCreatemodel(false);
                getNetworks();
            } else {
                toast.error(response?.data?.message);
            }

        } catch (error) {
            console.error("Error creating network", error);
        } finally {
            setIsLoad(false);
        }
    };

    return (
        <div className="Asset">
            <Box sx={{ display: lg ? "flex" : "block" }}>
                <Header />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 5,
                        width: { lg: `calc(100% - ${drawerWidth}px)` },
                        marginTop: "50px",
                    }}
                >
                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Button
                                variant="contained"
                                sx={{ marginLeft: "auto", display: "block", marginTop: "20px" }}
                                onClick={() => { setOpenCreatemodel(!openCreateModel); }}
                            >
                                Create
                            </Button>
                            <div className="custom_table">
                                <TableContainer>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                {tabelHeader.map((val, index) => {
                                                    return <TableCell align="center"> {val}</TableCell>;
                                                })}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {[...result]
                                                .slice((page - 1) * limit, page * limit)
                                                ?.map((value, index) => (
                                                    <TableRow
                                                        key={index}
                                                        sx={{
                                                            "&:last-child td, &:last-child th": { border: 0 },
                                                        }}
                                                    >
                                                        <TableCell
                                                            component="th"
                                                            scope="row"
                                                            align="center"
                                                        >
                                                            {limit * (page - 1) + index + 1}
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            {value?.Network_name}
                                                        </TableCell>

                                                        <TableCell align="center">{value?.Rpcurl}</TableCell>
                                                        <TableCell align="center">
                                                            <Button
                                                                variant="contained"
                                                                onClick={() => { handleClickOpen(value) }}
                                                            >
                                                                Edit
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Pagination
                                    className="pagnation"
                                    count={totalPage}
                                    page={page}
                                    onChange={(event, value) => {
                                        setPage(value);
                                    }}
                                    // color='primary'
                                    shape="rounded"
                                />
                            </div>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openModel}
                className="edit-dialogbox"
                sx={{
                    "& .MuiDialog-paper": {
                        backgroundColor: "#10212c",
                        color: "#fff",
                        width: "900px",
                        margin: 0,
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    EDIT
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>

                    {/* Form Fields */}
                    <Grid2
                        container
                        spacing={2}
                        style={{ height: "100%" }}
                        alignItems={"center"}
                    >
                        {/* Left Column */}
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                            sx={{
                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                    color: "white",
                                },

                            }}
                        >
                            <div className="view-inp p-10">
                                <div className=" txt-white ">Name</div>
                                <div className="mt-10">
                                    <TextField
                                        value={pairDetils?.Network_name}
                                        onChange={(e) =>
                                            setPairDetils((prev) => ({ ...prev, Network_name: e.target.value }))
                                        }
                                        id="outlined-basic"
                                        variant="outlined"
                                        fullWidth
                                    />
                                </div>
                            </div>

                        </Grid2>

                        {/* Right Column */}
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                            sx={{
                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                    color: "white",
                                },

                            }}
                        >
                            <div className="view-inp p-10">
                                <div className=" txt-white ">RPC URL</div>
                                <div className="mt-10">
                                    <TextField
                                        value={pairDetils?.Rpcurl}
                                        onChange={(e) =>
                                            setPairDetils((prev) => ({ ...prev, Rpcurl: e.target.value }))
                                        }
                                        id="outlined-basic"
                                        variant="outlined"
                                        fullWidth
                                    />
                                </div>
                            </div>

                        </Grid2>
                    </Grid2>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSave} autoFocus disabled={isLoad} variant="contained">
                        Save changes
                    </Button>
                </DialogActions>
            </BootstrapDialog>


            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openCreateModel}
                className="edit-dialogbox"
                sx={{
                    "& .MuiDialog-paper": {
                        backgroundColor: "#10212c",
                        color: "#fff",
                        width: "900px",
                        margin: 0,
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    CREATE NETWORK
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => { setOpenCreatemodel(!openCreateModel) }}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>

                    {/* Form Fields */}
                    <Grid2
                        container
                        spacing={2}
                        style={{ height: "100%" }}
                        alignItems={"center"}
                    >
                        {/* Left Column */}
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                            sx={{
                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                    color: "white",
                                },

                            }}
                        >
                            <div className="view-inp p-10">
                                <div className=" txt-white ">Name</div>
                                <div className="mt-10">
                                    <TextField
                                        value={networkname}
                                        onChange={(e) => { setNetworkName(e?.target?.value) }}
                                        id="outlined-basic"
                                        variant="outlined"
                                        fullWidth
                                    />
                                </div>
                            </div>

                        </Grid2>

                        {/* Right Column */}
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                            sx={{
                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                    color: "white",
                                },

                            }}
                        >
                            <div className="view-inp p-10">
                                <div className=" txt-white ">RPC URL</div>
                                <div className="mt-10">
                                    <TextField
                                        value={rpcUrl}
                                        onChange={(e) => { setRpcUrl(e?.target?.value) }}
                                        id="outlined-basic"
                                        variant="outlined"
                                        fullWidth
                                    />
                                </div>
                            </div>

                        </Grid2>
                    </Grid2>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={createNetwork} disabled={isLoad} variant="contained">
                        Create Network
                    </Button>
                </DialogActions>
            </BootstrapDialog>

            <Toaster />
        </div>
    );
};

export default Network;
